/** @jsxImportSource @emotion/react */
import { css, Theme } from '@emotion/react';

declare module '@emotion/react' {
  export interface Theme {
    palette: {
      // New styles
      navLinkcolor: string;
      primaryButtonColor: string;
      tertiaryBgColor: string;
      // new latest style
      footerBgColor: string;
      redFontColor: string;
      redHoverFontColor: string;
      borderColor: string;
      darkBorderColor: string;
      darkestBorderColor: string;
      highlightColor: string;
      offWhite: string;
      blackColor: string;
      darkTextColor: string;
      lightPink: string;
    };
  }
}

export const theme: Theme = {
  palette: {
    // New styles
    navLinkcolor: '#1F2B34',
    primaryButtonColor: '#DA0E29',
    tertiaryBgColor: '#FAFBFB',

    // new latest styles
    footerBgColor: '#073506',
    redFontColor: '#DA0E29',
    redHoverFontColor: '#da0e29e8',
    darkBorderColor: '#D2D5DA',
    darkestBorderColor: '#9CA3AF',
    borderColor: '#E5E7EB',
    offWhite: '#F8F8F8',
    highlightColor: '#F6F6F6',
    blackColor: '#000000',
    darkTextColor: '#4D5462',
    lightPink: '#FEF5F7',
  },
};

const GlobalStyles = css`
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
  * {
    margin: 0;
    font-size: 1em;
  }
  html,
  body {
    height: 100%;
  }
  body {
    line-height: 1.5;
    -webkit-font-smoothing: antialiased;
    font-family: 'Manrope', 'Work Sans', sans-serif;
    font-weight: 400;
    color: black;
    overflow-x: hidden;
  }
  img,
  picture,
  video,
  canvas,
  svg {
    display: block;
    max-width: 100%;
  }
  input,
  button,
  textarea,
  select {
    font: inherit;
  }
  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    overflow-wrap: break-word;
  }
  #root,
  #__next {
    isolation: isolate;
  }
`;

export default GlobalStyles;
